module.exports = __webpack_public_path__ + "media/images/sp/top/recommend-plan-maedori1-3048ed5f24eb80556faa2adb5376fccf.jpg";